import { AuthContext } from 'App'
import { fetchGuillotina } from 'NewVersion/services/guillotina'
import { swrOptions, swrOptionsStatic } from 'NewVersion/utils/swrOptions'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'
import useSWR from 'swr'
import { getCurrentJWToken } from 'utils/utils'

export function useGuillotina({ path, useStatic = false, getFile = false, guillotinadb = false }) {
  const { dispatch } = useContext(AuthContext)
  const token = getCurrentJWToken()
  const navigate = useNavigate()
  let normalizedPath = path
  if (normalizedPath && normalizedPath.includes(process.env.REACT_APP_GUILLOTINA)) {
    normalizedPath = normalizedPath.replace(process.env.REACT_APP_GUILLOTINA, '')
  }
  if (normalizedPath && normalizedPath.charAt(0) === '/') {
    normalizedPath = normalizedPath.substring(1)
  }
  const swrKey = normalizedPath ? [normalizedPath, token ?? null, !!getFile, !!guillotinadb] : null

  const { data, error, mutate, isLoading } = useSWR(
    swrKey,
    ([url]) =>
      fetchGuillotina({
        path: url,
        checkError: true,
        getFile,
        token,
        guillotinadb,
      }),
    useStatic ? swrOptionsStatic : swrOptions
  )

  useEffect(() => {
    if (error && error.status === 401) {
      console.log('Error unauth')
      dispatch({
        type: 'LOGOUT',
      })
      navigate(path.LOGIN_PATH)
    }
  }, [error])

  return {
    data,
    isLoading,
    error,
    refresh: mutate,
  }
}
